export default __webpack_public_path__ + "static/media/3rd.60667819.jpg";